
const INF_LOGIN_URL = `https://collab.boltnutritions.com/api/check-user?email=`;

function getUserData() {
    const userData = localStorage.getItem("user");
    return userData ? JSON.parse(userData) : null;
}

function isLoggedIn() {
    return !!getUserData();
}

function logout() {
    localStorage.removeItem("user");
    window.location.href = "https://boltnutritions.com/pages/influencer-login";
}

// UI Helper functions
function showElement(element, show = true) {
    if (!element) return;
    if (show) {
        element.classList.replace("hide", "active");
    } else {
        element.classList.replace("active", "hide");
    }
}

function resetButton(button) {
    if (!button) return;
    button.disabled = false;
    const buttonText = button.querySelector(".button-text");
    if (buttonText) {
        buttonText.textContent = button.dataset.originalText || "Submit";
    }
}

function setButtonLoading(button, loading = true) {
    if (!button) return;
    button.disabled = loading;
    const buttonText = button.querySelector(".button-text");
    if (buttonText) {
        if (loading) {
            button.dataset.originalText = buttonText.textContent;
            buttonText.textContent = "Loading...";
        } else {
            buttonText.textContent = button.dataset.originalText || "Submit";
        }
    }
}

// Form toggle functions
function togglePasswordVisibility(button) {
    const input = document.getElementById(button.dataset.target);
    if (!input) return;

    const isPassword = input.type === 'password';
    input.type = isPassword ? 'text' : 'password';

    const icon = button.querySelector("i") || button.querySelector("svg");
    if (icon) {
        if (isPassword) {
            icon.classList.replace('bi-eye', 'bi-eye-slash');
        } else {
            icon.classList.replace('bi-eye-slash', 'bi-eye');
        }
    }
}

function showSection(sectionId) {
    document.querySelectorAll(".form-section").forEach(s => s.classList.remove("active"));
    const targetSection = document.getElementById(sectionId);
    if (targetSection) {
        targetSection.classList.add("active");
    }
}

// Initialize password toggle buttons
function initPasswordToggles() {
    document.querySelectorAll(".toggle-password").forEach(btn => {
        btn.addEventListener("click", () => togglePasswordVisibility(btn));
    });
}

// Initialize sidebar navigation
function initSidebarNavigation() {
    const menu = document.querySelector(".dashboard-sidebar .nav-menu");
    const links = document.querySelectorAll(".dashboard-sidebar .nav-menu a");
    const sections = document.querySelectorAll("#DashboardContent .dashboard-section");
    const sidebar = document.querySelector(".dashboard-sidebar");

    function activateSection(targetId) {
        links.forEach(link => {
            const linkTarget = link.dataset.target.replace("#", "");
            link.classList.toggle("active", linkTarget === targetId);
        });

        sections.forEach(section => {
            section.classList.toggle("hide", section.id !== targetId);
        });

        setTimeout(() => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }, 0);

        sidebar?.classList.remove("active");
    }

    menu?.addEventListener("click", (e) => {
        const link = e.target.closest("a");
        if (!link) return;

        e.preventDefault();
        const targetId = link.dataset.target.replace("#", "");
        
        window.location.hash = targetId;
        activateSection(targetId);
    });

    const hash = window.location.hash.replace("#", "");
    activateSection(hash || "profile");
}

function initMobileSidebar() {
    const menuToggle = document.querySelector('.navbar-toggler');
    const sideBarMenu = document.querySelector('.dashboard-sidebar');
    const closeToggle = document.querySelector(".dashboard-logo-icon button");

    menuToggle?.addEventListener('click', function() {
        if (sideBarMenu) {
            sideBarMenu.classList.toggle("active");
        }
    });

    closeToggle?.addEventListener('click', function() {
        if (sideBarMenu) {
            sideBarMenu.classList.remove("active");
        }
    });
}

// Password strength checker
function initPasswordStrength() {
    const input = document.getElementById("NewPassword");
    if (!input) return;

    const strengthBar = document.getElementById("strengthBar");
    const strengthText = document.getElementById("strengthText");

    input.addEventListener("input", function() {
        const val = this.value;
        let score = 0;

        const requirements = {
            'length': val.length >= 8,
            'upper': /[A-Z]/.test(val),
            'lower': /[a-z]/.test(val),
            'number': /[0-9]/.test(val),
            'special': /[!@#$%^&*(),.?":{}|<>]/.test(val)
        };

        Object.keys(requirements).forEach(key => {
            const reqItem = document.getElementById(`req-${key}`);
            if (reqItem) {
                const icon = reqItem.querySelector('i') || reqItem.querySelector('svg');
                if (requirements[key]) {
                    score++;
                    reqItem.classList.remove('text-muted');
                    reqItem.classList.add('text-success');
                    if (icon && icon.classList.contains('bi-circle')) {
                        icon.classList.replace('bi-circle', 'bi-check-circle-fill');
                    }
                } else {
                    reqItem.classList.remove('text-success');
                    reqItem.classList.add('text-muted');
                    if (icon && icon.classList.contains('bi-check-circle-fill')) {
                        icon.classList.replace('bi-check-circle-fill', 'bi-circle');
                    }
                }
            }
        });

        // Update Strength Bar UI
        if (strengthBar && strengthText) {
            let width = (score / 5) * 100;
            strengthBar.style.width = width + '%';

            if (val.length === 0) {
                strengthBar.className = "progress-bar bg-secondary"; 
                strengthText.innerText = 'Empty';
                strengthText.className = 'fw-bold text-muted';
            } else if (score <= 2) {
                strengthBar.className = "progress-bar bg-danger";
                strengthText.innerText = "Weak";
                strengthText.className = "fw-bold text-danger";
            } else if (score <= 4) {
                strengthBar.className = "progress-bar bg-warning text-dark";
                strengthText.innerText = "Medium";
                strengthText.className = "fw-bold text-warning";
            } else {
                strengthBar.className = "progress-bar bg-success";
                strengthText.innerText = "Strong";
                strengthText.className = "fw-bold text-success";
            }
        }
    });
}

// Contact form handler
function initContactForm() {
    const contactForm = document.getElementById('contactForm');
    if (!contactForm) return;

    contactForm.addEventListener('submit', function (e) {
        e.preventDefault();

        const btn = document.getElementById('submitBtn');
        const spinner = document.getElementById('loadingSpinner');
        const successAlert = document.getElementById('successAlert');
        const errorAlert = document.getElementById('errorAlert');

        const scriptURL = "https://script.google.com/macros/s/AKfycbxq94FePBg_QcllM6rlDNKwkDeUM9ugoHDoW38PHeOE8JluzWPsS3R5sAgC0VKdR-t_EQ/exec";

        let storedName = "Unknown Influencer";
        let storedEmail = "no-email@found.com";

        const userData = getUserData();
        if (userData) {
            storedName = userData.name || storedName;
            storedEmail = userData.email || storedEmail;
        }

        btn.disabled = true;
        spinner?.classList.remove('d-none');
        successAlert?.classList.add('d-none');
        errorAlert?.classList.add('d-none');

        const formData = {
            name: storedName,
            email: storedEmail,
            subject: document.getElementById('contactSubject').value,
            campaignId: document.getElementById('contactCampaignId').value,
            message: document.getElementById('contactMessage').value
        };

        fetch(scriptURL, {
            method: 'POST',
            mode: 'no-cors',
            cache: 'no-cache',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
        .then(() => {
            spinner?.classList.add('d-none');
            btn.disabled = false;
            successAlert?.classList.remove('d-none');
            contactForm.reset();
        })
        .catch(error => {
            spinner?.classList.add('d-none');
            btn.disabled = false;
            errorAlert?.classList.remove('d-none');
            console.error('Submission Error:', error);
        });
    });
}

// Terms and Privacy modals
function initTermsAndPrivacy() {
    function openPrivacy() {
        const modal = document.getElementById('privacyModal');
        if (modal) {
            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        }
    }

    function closePrivacy() {
        const modal = document.getElementById('privacyModal');
        if (modal) {
            modal.style.display = 'none';
            document.body.style.overflow = 'auto';
        }
    }

    // Attach event listeners
    document.querySelectorAll('[onclick*="openPrivacy"]').forEach(el => {
        el.addEventListener('click', openPrivacy);
    });

    document.querySelectorAll('[onclick*="closePrivacy"]').forEach(el => {
        el.addEventListener('click', closePrivacy);
    });

    const modal = document.getElementById('privacyModal');
    if (modal) {
        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                closePrivacy();
            }
        });
    }

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closePrivacy();
        }
    });
}

document.addEventListener("DOMContentLoaded", function() {
    initPasswordToggles();
    initMobileSidebar();
    initPasswordStrength();
    initContactForm();
    initTermsAndPrivacy();
    initSidebarNavigation();
});

// DOM Elements
const loginPage = document.getElementById("LoginPage");
const loginForm = document.getElementById("CustomLoginForm");
const registerForm = document.getElementById("CustomRegisterForm");
const loginErrorMsg = document.getElementById("LoginErrorMessage");
const loginBtn = document.getElementById("LoginSubmitBtn");

function initLogin() {
    const user = getUserData();

    if (user && user.email) {
        showElement(loginPage, false);
        
        if (typeof initDashboard === 'function') {
            initDashboard();
        } else {
            window.location.href = "https://boltnutritions.com/pages/influencer-login#DashboardContent";
        }
    } else {
        showElement(loginPage, true);
        
        setupFormToggles();
        initRegistration();
    }
}

// Form section toggles
function setupFormToggles() {
    document.getElementById("ShowRegisterForm")?.addEventListener("click", (e) => {
        e.preventDefault();
        showSection("RegisterFormSection");
    });

    document.getElementById("ShowForgotPassword")?.addEventListener("click", (e) => {
        e.preventDefault();
        showSection("ForgotPasswordSection");
    });

    document.querySelectorAll(".back-link, #CancelForgotPassword").forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            showSection("LoginFormSection");
        });
    });
}

// Login form submission
function initLoginForm() {
    if (!loginForm) return;

    loginForm.addEventListener("submit", async (e) => {
        e.preventDefault();

        const email = document.getElementById("LoginEmail").value.trim();
        const password = document.getElementById("LoginPassword").value.trim();

        loginErrorMsg.style.display = "none";

        if (!email || !password) {
            loginErrorMsg.textContent = "Enter email and password";
            loginErrorMsg.style.display = "block";
            return;
        }

        setButtonLoading(loginBtn, true);

        try {
            const res = await fetch(`https://collab.boltnutritions.com/api/influencers_login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await res.json();

             if (data.success) {
            localStorage.setItem("user", JSON.stringify({
                email: data.user.email,
                infNo: data.user.infNo,
                role: data.user.role,
                name: `${data.user.first_name || ""} ${data.user.last_name || ""}`.trim()
            }));
            window.location.href = "https://boltnutritions.com/pages/influencer-login#DashboardContent";
            window.location.reload();
            } else {
                loginErrorMsg.textContent = data.message;
                loginErrorMsg.style.display = "block";
                resetButton(loginBtn);
            }
        } catch (err) {
            console.error(err);
            loginErrorMsg.textContent = "Connection error. Try again.";
            // loginErrorMsg.textContent = "The server is currently under maintenance. Please try again later.";

            loginErrorMsg.style.display = "block";
            resetButton(loginBtn);
        }
    });
}

function initRegistration() {
    const registerForm = document.getElementById("CustomRegisterForm");
    if (!registerForm) return;

    const errorBox = document.getElementById("RegisterErrorMessage");
    const successBox = document.getElementById("RegisterSuccessMessage");
    const btn = document.getElementById("RegisterSubmitBtn");

    const followersEl = document.getElementById("followersCount");
    const followingEl = document.getElementById("followingCount");

    // ---------- HELPERS ----------
    function showRegisterError(msg) {
        errorBox.textContent = msg;
        errorBox.style.display = "block";
    }

    function setButtonLoading(loading) {
        btn.disabled = loading;
        btn.querySelector(".button-text").textContent = loading
            ? "Creating..."
            : "Create Account";
    }

    function resetButton() {
        setButtonLoading(false);
    }

    function validateAndExtractInstagramUsername(url) {
        if (!url || url.trim() === '') {
            return { isValid: false, username: null, error: "Instagram profile URL is required" };
        }
        
        url = url.trim();
        
        const instagramPattern = /^(https?:\/\/)?(www\.)?instagram\.com\/([a-zA-Z0-9._](?!.*\.\.)[a-zA-Z0-9._]{1,30})(\/?.*)?$/;
        const match = url.match(instagramPattern);
        
        if (!match) {
            return { 
                isValid: false, 
                username: null, 
                error: "Please enter a valid Instagram profile URL (e.g., https://www.instagram.com/username)" 
            };
        }
        
        const username = match[3];
        
        if (!username || username.length < 1) {
            return { 
                isValid: false, 
                username: null, 
                error: "Instagram username is missing in the URL" 
            };
        }
        
        return { isValid: true, username: username, error: null };
    }

    function extractInstagramUsername(url) {
        if (!url) return null;
        const validation = validateAndExtractInstagramUsername(url);
        return validation.isValid ? validation.username : null;
    }

    // ---------- INSTAGRAM FETCH ----------
    let instagramDataPromise = null;

    async function fetchInstagramProfile(username) {
        if (!username) return null;

        if (!instagramDataPromise) {
            const API_URL = `https://collab.boltnutritions.com/api/instagram/userProfile?username=${encodeURIComponent(username)}`;

            instagramDataPromise = fetch(API_URL)
                .then(res => res.ok ? res.json() : null)
                .then(json => json?.success ? json.data : null)
                .catch(err => {
                    console.error("Instagram API error:", err);
                    return null;
                });
        }

        return instagramDataPromise;
    }

    async function loadFollowersAndFollowing(instaUrl) {
        const username = extractInstagramUsername(instaUrl);
        if (!username) return { followers: 0, following: 0 };

        const data = await fetchInstagramProfile(username);
        if (!data) return { followers: 0, following: 0 };

        if (followersEl) {
            followersEl.textContent = (data.followers ?? 0).toLocaleString();
        }

        if (followingEl) {
            followingEl.textContent = (data.following ?? 0).toLocaleString();
        }

        return {
            followers: data.followers ?? 0,
            following: data.following ?? 0
        };
    }

    // ---------- SUBMIT ----------
    registerForm.addEventListener("submit", async function (e) {
        e.preventDefault();

        errorBox.style.display = "none";
        successBox.style.display = "none";

        const mobileNumber = document.getElementById("RegisterMobile").value.trim();
        const fullMobileNumber = mobileNumber ? `+91${mobileNumber}` : "";

        const instagramProfile =
            document.getElementById("RegisterInstagram").value.trim();

        const instagramValidation = validateAndExtractInstagramUsername(instagramProfile);
        
        if (!instagramValidation.isValid) {
            return showRegisterError(instagramValidation.error);
        }

        const instaStats = await loadFollowersAndFollowing(instagramProfile);

        const formData = {
            first_name: document.getElementById("RegisterFirstName").value.trim(),
            last_name: document.getElementById("RegisterLastName").value.trim(),
            mobile: fullMobileNumber,
            email: document.getElementById("RegisterEmail").value.trim(),
            instagram_profile: instagramProfile, // Keep original URL
            state: document.getElementById("RegisterState").value.trim(),
            city: document.getElementById("RegisterCity").value.trim(),
            pincode: document.getElementById("RegisterPincode").value.trim(),
            password: document.getElementById("RegisterPassword").value,
            confirm_password: document.getElementById("RegisterConfirmPassword").value,
            terms: document.getElementById("RegisterTerms").checked,
            follower_count: instaStats.followers,
            following_count: instaStats.following
        };

        // ---------- VALIDATION ----------
        for (let key in formData) {
            if (key !== "terms" && !formData[key]) {
                return showRegisterError("All fields are required.");
            }
        }

        if (!/^\d{10}$/.test(mobileNumber)) {
            return showRegisterError("Please enter a valid 10-digit mobile number.");
        }

        if (!/^\d{6}$/.test(formData.pincode)) {
            return showRegisterError("Please enter a valid 6-digit pincode.");
        }

        if (formData.password.length < 6) {
            return showRegisterError("Password must be at least 6 characters.");
        }

        if (formData.password !== formData.confirm_password) {
            return showRegisterError("Passwords do not match.");
        }

        if (!formData.terms) {
            return showRegisterError("Please accept the Terms & Conditions.");
        }

        // ---------- API ----------
        setButtonLoading(true);

        try {
            const res = await fetch(
                "https://collab.boltnutritions.com/api/register",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData)
                }
            );

            const data = await res.json();

            if (!data.success) {
                return showRegisterError(data.message || "Registration failed.");
            }

            successBox.textContent =
                data.message || "Account created successfully.";
            successBox.style.display = "block";

            registerForm.reset();

            setTimeout(() => {
                showSection("LoginFormSection");
                successBox.style.display = "none";
            }, 2000);
        } catch (err) {
            console.error(err);
            showRegisterError("Server error. Please try again.");
        } finally {
            resetButton();
        }
    });
}

function initForgotPassword() {
    const forgotForm = document.getElementById("ForgotPasswordForm");
    if (!forgotForm) return;

    forgotForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        const email = document.getElementById("ForgotEmail").value.trim();
        const btn = forgotForm.querySelector('button[type="submit"]');
        const messageDiv = document.getElementById("forgotPasswordMessage");

        if (!email) {
            showMessage("Please enter your email address", "error");
            return;
        }

        setButtonLoading(btn, true);

        try {
            // This endpoint needs to be implemented on your backend
            const res = await fetch("https://collab.boltnutritions.com/api/forgot-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email })
            });

            const data = await res.json();

            if (data.success) {
                showMessage("Password reset instructions sent to your email", "success");
                forgotForm.reset();
            } else {
                showMessage(data.message || "Failed to send reset email", "error");
            }
        } catch (err) {
            console.error(err);
            showMessage("Connection error. Please try again.", "error");
        } finally {
            resetButton(btn);
        }

        function showMessage(msg, type) {
            if (messageDiv) {
                messageDiv.textContent = msg;
                messageDiv.className = `alert alert-${type === 'success' ? 'success' : 'danger'} mt-3`;
                messageDiv.style.display = 'block';
            }
        }
    });
}

// Initialize login page
document.addEventListener("DOMContentLoaded", function() {
    initLogin();
    initLoginForm();
    initForgotPassword();
});
// cart logo
document.addEventListener("DOMContentLoaded", () => {   
    const cartBtn = document.getElementById("floatingCartBtn");
    const notif = document.getElementById("notifBubble");
    if (!cartBtn || !notif) return;

    const user = JSON.parse(localStorage.getItem("user") || "{}");

    if (user.email) {
        cartBtn.classList.remove("d-none");
    } else {
        cartBtn.classList.add("d-none");
        return;
    }

    function showNotification() {
        notif.classList.add("show");
        setTimeout(() => {
            notif.classList.remove("show");
        },3000); 
    }

    cartBtn.addEventListener("mouseenter", showNotification);
    cartBtn.addEventListener("click", showNotification);

    setInterval(showNotification, 60000);
});

document.addEventListener('DOMContentLoaded', function() {
    const typeButtons = document.querySelectorAll('.content-type-btn');
    const urlFields = document.querySelectorAll('.url-field');
    
    typeButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Remove active class from all buttons and fields
            typeButtons.forEach(btn => btn.classList.remove('active'));
            urlFields.forEach(field => field.classList.add('d-none'));
            
            // Add active class to clicked button
            this.classList.add('active');
            
            // Show corresponding URL field
            const contentType = this.dataset.type;
            const targetField = document.querySelector(`.url-field[data-content-type="${contentType}"]`);
            if (targetField) {
                targetField.classList.remove('d-none');
            }
        });
    });
});